module.exports = __webpack_public_path__ + "static/media/Camada_1.c45da21d.svg";